import  React from 'react'
import Button from 'react-bootstrap/Button'
import { MilestoneConsultantModel } from '../../../../../models/MilestoneConsultantModel'
import { TextField, validateFields, AddressField, MoneyField, MultiLineField, EmailField } from '../../../../../shared/fields'
import { TableColumn, ISection } from '../../../../../shared/table'
import { ShowIf } from '../../../../../shared/fields/ShowIf'
import { ISupportSpinner } from '../../../../../shared/Ajax'
import { Backdrop } from '../../../../../shared/Backdrop'
import { MilestoneModel } from '../../../../../models/MilestoneModel'
import { Option } from '../../../../../models/Option'

export const MilestoneConsultantColumns: TableColumn<MilestoneConsultantModel>[] = [
    { name: 'Consultant name', content: (d) => `${d.firstName} ${d.lastName}` },
    { name: 'Consultant cost (in $AU)', content: (d) => d.cost }
]

export interface MilestoneConsultantDetailsProps {
    id: string
    model: MilestoneConsultantModel
    onChange: { (v: MilestoneConsultantModel, close: boolean): any }
    onClose: { (): any }
    onRemove: { (): any }
    importing: boolean
    preview?: boolean
    milestone: MilestoneModel
    addressCountries: Option<string>[]
}

export interface MilestoneConsultantDetailsState {
    model: MilestoneConsultantModel
    loading: boolean
}

export class MilestoneConsultantDetails extends React.Component<MilestoneConsultantDetailsProps, MilestoneConsultantDetailsState> implements ISection, ISupportSpinner {
    representativeCost: MoneyField
    firstName: TextField
    lastName: TextField
    physicalAddress: AddressField
    emailAddress: TextField
    phoneNumber: TextField
    expenseBreakdown: MultiLineField

    constructor(props: MilestoneConsultantDetailsProps) {
        super(props)

        const model: MilestoneConsultantModel = this.props.model ? { ...this.props.model } : {
            milestoneConsultantID: 0,
            milestoneReportID: this.props.milestone.milestoneReportID,
            cost: 0,
            firstName: '',
            lastName: '',
            emailAddress: '',
            isManualAddress: false,
            phoneNumber: '',
            address: null,
            expenseBreakdown: '',
            invalid: false,
            rowState: 1
        }

        this.state = {
            model,
            loading: false,
        }
    }

    toggleSpinner(on: boolean, callback: { (): any }): void {
        this.setState({ loading: on }, callback)
    }

    validate = (callback: { (res: boolean): any }) => {
        validateFields((res) => this.onChange({ invalid: !res }, () => callback(res)),
            this.representativeCost,
            this.firstName,
            this.lastName,
            this.physicalAddress,
            this.emailAddress,
            this.phoneNumber,
            this.expenseBreakdown)
    }

    saveAndClose = (callback?: { (res: boolean): any }) => {
        if (this.state.loading) {
            callback && callback(false)
            return
        }
        this.validate((res) => {
            if (res) {
                this.props.onChange(this.state.model, true)
            }
            callback && callback(res)
        })
    }

    componentDidMount() {
        if (this.props.importing) {
            this.validate((res) => {
                const temp = { invalid: !res }
                this.props.onChange({ ...this.state.model, ...temp }, true)
            })
        } else if (this.state.model.invalid) {
            this.validate(() => { })
        }
    }

    onChange = (change: Partial<MilestoneConsultantModel>, callback?: { (): any }) => {
        this.setState({
            model: { ...this.state.model, ...change },
        }, callback)
    }

    render() {

        const { model } = this.state
        const { preview } = this.props

        return (
            <>
                <MoneyField ref={r => this.representativeCost = r}
                    id={`${this.props.id}-OverseasRepCost`}
                    label="Cost of the consultant (in AU$)"
                    value={model.cost}
                    min={60000}
                    minMessage={'Minimum cost is $60000'}
                    allowNegative={false}
                    onChange={cost => this.onChange({ cost })}
                    preview={preview}
                    required
                />

                <TextField
                    ref={(r) => this.firstName = r}
                    id={`${this.props.id}-ReFirstName`}
                    label="First name"
                    value={model.firstName}
                    onChange={(firstName) => this.onChange({ firstName })}
                    required
                    preview={preview}
                    maxLength={80}
                />

                <TextField
                    ref={(r) => this.lastName = r}
                    id={`${this.props.id}-RepLastName`}
                    label="Last name"
                    value={model.lastName}
                    onChange={(lastName) => this.onChange({ lastName })}
                    preview={preview}
                    required
                    maxLength={80}
                />

                <EmailField
                    ref={(r) => this.emailAddress = r}
                    id={`${this.props.id}-EmailAddress`}
                    label="Email address"
                    value={model.emailAddress}
                    onChange={(emailAddress) => this.onChange({ emailAddress })}
                    preview={preview}
                    required
                    maxLength={80}
                />

                <TextField
                    ref={(r) => this.phoneNumber = r}
                    id={`${this.props.id}-PhoneNumber`}
                    label="Phone number"
                    value={model.phoneNumber}
                    onChange={(phoneNumber) => this.onChange({ phoneNumber })}
                    preview={preview}
                    required
                    maxLength={15}
                />

                <AddressField
                    ref={(r) => this.physicalAddress = r}
                    id={`${this.props.id}-physicalAddress`}
                    label="Registered address"
                    value={model.address}
                    onChange={(address) => this.onChange({ address })}
                    preview={preview}
                    australianAddressesOnly={false}
                    required
                    countries={this.props.addressCountries}
                />

                <MultiLineField ref={r => this.expenseBreakdown = r}
                    id={`${this.props.id}-ExpenseBreakdonw`}
                    label="Provide a breakdown of how the expenses were paid (EFT, Cash, Contra) and when the expenses were paid."
                    value={model.expenseBreakdown}
                    onChange={expenseBreakdown => this.onChange({ expenseBreakdown })}
                    preview={preview}
                    required
                    maxLength={3000}
                />
                <br />
                <ShowIf condition={!preview} className="clearfix mt-3">
                    <Button className="emdg-btn float-right" onClick={(e) => this.saveAndClose()}>Complete row</Button>
                    <Button className="emdg-btn emdg-btn--secondary float-left mr-2" onClick={this.props.onClose}>Cancel</Button>
                    <Button className="emdg-btn emdg-btn--secondary float-left" onClick={this.props.onRemove} style={{ display: this.props.model ? '' : 'none' }}>Remove</Button>
                </ShowIf>

                <Backdrop on={this.state.loading} />
            </>
        )
    }
}
